import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Box, Container, Grid, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import InternalSlidePage from '../components/resuableComponents/InternalSlidePage';
import Faq from '../components/resuableComponents/Faq';
import { Watermark } from 'antd';
const slider = [
	'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1932&q=80',
	'https://images.unsplash.com/photo-1475189778702-5ec9941484ae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80',
	'https://images.pexels.com/photos/18201084/pexels-photo-18201084/free-photo-of-sky-tower-over-buildings-in-auckland-at-sunset.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
	'https://wallpapercave.com/wp/wp9388467.jpg',
];
const HolidaysDetailPage = () => {
	const location = useLocation();
	console.log('location', location);
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<div>
			<Watermark content='Musafir Bazar'>
				<Navbar />
				<div className='header' style={{ marginTop: 80 }}>
					<div className='progress-container'>
						<div className='progress-bar' id='progressBar'></div>
					</div>
				</div>
				<Container style={{ marginTop: 30 }}>
					<Grid container spacing={4}>
						<Grid item xs={8}>
							<Box>
								<h1 style={{ fontSize: 22, fontWeight: 'bold' }}>
									Heavenly Tour to Maldives
								</h1>
								<p style={{ marginTop: 10 }}>CITIES COVERED</p>
							</Box>
							<br></br>
							<InternalSlidePage images={slider} />
							<Box
								mt={1}
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									border: '1px solid lightgrey',
									padding: 10,
								}}>
								<Box>
									<i class='fa fa-plane' aria-hidden='true'></i>
									<span style={{ marginLeft: 5 }}>Flights</span>
								</Box>{' '}
								<Box>
									<i class='fa-solid fa-hotel'></i>
									<span style={{ marginLeft: 5 }}>Hotel Stay</span>
								</Box>{' '}
								<Box>
									<i class='fas fa-hamburger'></i>
									<span style={{ marginLeft: 5 }}>Meals</span>
								</Box>{' '}
								<Box>
									<i class='fa fa-automobile'></i>
									<span style={{ marginLeft: 5 }}>Transfers</span>
								</Box>{' '}
								<Box>
									<span>Sightseeing</span>
								</Box>
								<Box>
									<i class='fa fa-ship' aria-hidden='true'></i>
									<span style={{ marginLeft: 5 }}>Cruise</span>
								</Box>
							</Box>
							<Box mt={2}>
								<h1
									style={{
										color: '#8f8056',
										fontWeight: 'bold',
										fontSize: 20,
										marginBottom: 5,
									}}>
									Overview
								</h1>
								<p style={{ fontSize: 13 }}>
									Maldives is an amazing nation which will attract you with its
									sandy white beaches, sparkling waters and outstanding marine
									life. Maldives tour offer you an opportunity to explore this
									island paradise in totality. The staggering beauty along with
									unparalleled tranquillity of this tropical archipelago will
									simply mesmerize you.
								</p>
							</Box>
							<Box mt={2}>
								<h1
									style={{
										color: '#8f8056',
										fontWeight: 'bold',
										fontSize: 20,
										marginBottom: 5,
									}}>
									Itinerary
								</h1>
								<Faq />
							</Box>
							<Box mt={2}>
								<h1
									style={{
										color: '#8f8056',
										fontWeight: 'bold',
										fontSize: 20,
										marginBottom: 5,
									}}>
									Hotel Detail
								</h1>
								<p style={{ fontSize: 13 }}>
									Maldives is an amazing nation which will attract you with its
									sandy white beaches, sparkling waters and outstanding marine
									life. Maldives tour offer you an opportunity to explore this
									island paradise in totality. The staggering beauty along with
									unparalleled tranquillity of this tropical archipelago will
									simply mesmerize you.
								</p>
							</Box>
							<Box mt={2}>
								<h1
									style={{
										color: '#8f8056',
										fontWeight: 'bold',
										fontSize: 20,
										marginBottom: 5,
									}}>
									Price Summary
								</h1>
								<p style={{ fontSize: 13 }}>
									Maldives is an amazing nation which will attract you with its
									sandy white beaches, sparkling waters and outstanding marine
									life. Maldives tour offer you an opportunity to explore this
									island paradise in totality. The staggering beauty along with
									unparalleled tranquillity of this tropical archipelago will
									simply mesmerize you.
								</p>
							</Box>
							<Box mt={2}>
								<h1
									style={{
										color: '#8f8056',
										fontWeight: 'bold',
										fontSize: 20,
										marginBottom: 5,
									}}>
									Inclusions
								</h1>
								<ul type='circle'>
									<li style={{ fontSize: 13 }}>
										1 Nights Accommodation in Amritsar
									</li>
									<li style={{ fontSize: 13 }}>
										1 Nights Accommodation in Amritsar
									</li>
									<li style={{ fontSize: 13 }}>
										1 Nights Accommodation in Amritsar
									</li>
									<li style={{ fontSize: 13 }}>
										1 Nights Accommodation in Amritsar
									</li>
									<li style={{ fontSize: 13 }}>
										1 Nights Accommodation in Amritsar
									</li>
									<li style={{ fontSize: 13 }}>
										1 Nights Accommodation in Amritsar
									</li>
									<li style={{ fontSize: 13 }}>
										1 Nights Accommodation in Amritsar
									</li>
									<li style={{ fontSize: 13 }}>
										1 Nights Accommodation in Amritsar
									</li>
								</ul>
							</Box>
							<Box mt={2}>
								<h1
									style={{
										color: '#8f8056',
										fontWeight: 'bold',
										fontSize: 20,
										marginBottom: 5,
									}}>
									Exclusions
								</h1>
								<p style={{ fontSize: 13 }}>
									Maldives is an amazing nation which will attract you with its
									sandy white beaches, sparkling waters and outstanding marine
									life. Maldives tour offer you an opportunity to explore this
									island paradise in totality. The staggering beauty along with
									unparalleled tranquillity of this tropical archipelago will
									simply mesmerize you.
								</p>
							</Box>{' '}
							<Box mt={2}>
								<h1
									style={{
										color: '#8f8056',
										fontWeight: 'bold',
										fontSize: 20,
										marginBottom: 5,
									}}>
									Cancelllation Policy
								</h1>
								<p style={{ fontSize: 13 }}>
									Maldives is an amazing nation which will attract you with its
									sandy white beaches, sparkling waters and outstanding marine
									life. Maldives tour offer you an opportunity to explore this
									island paradise in totality. The staggering beauty along with
									unparalleled tranquillity of this tropical archipelago will
									simply mesmerize you.
								</p>
							</Box>
							<Box mt={2}>
								<h1
									style={{
										color: '#8f8056',
										fontWeight: 'bold',
										fontSize: 20,
										marginBottom: 5,
									}}>
									Important Notice
								</h1>
								<p style={{ fontSize: 13 }}>
									Maldives is an amazing nation which will attract you with its
									sandy white beaches, sparkling waters and outstanding marine
									life. Maldives tour offer you an opportunity to explore this
									island paradise in totality. The staggering beauty along with
									unparalleled tranquillity of this tropical archipelago will
									simply mesmerize you.
								</p>
							</Box>
							<Box mt={2}>
								<h1
									style={{
										color: '#8f8056',
										fontWeight: 'bold',
										fontSize: 20,
										marginBottom: 5,
									}}>
									Extra Activity
								</h1>
								<p style={{ fontSize: 13 }}>
									Maldives is an amazing nation which will attract you with its
									sandy white beaches, sparkling waters and outstanding marine
									life. Maldives tour offer you an opportunity to explore this
									island paradise in totality. The staggering beauty along with
									unparalleled tranquillity of this tropical archipelago will
									simply mesmerize you.
								</p>
							</Box>
						</Grid>
						<Grid item xs={4}>
							<Box style={{ border: '2px dashed #93a9b4' }} mt={2}>
								<Box style={{ padding: 10, background: 'lightgrey' }} mb={1}>
									<h1 style={{ textAlign: 'center' }}>Send a Query</h1>
								</Box>
								<h1 style={{ textAlign: 'center' }}>On Demand</h1>

								<Box
									mt={1}
									mb={3}
									style={{
										padding: 10,
										background: 'red',
										marginLeft: 15,
										marginRight: 15,
										borderRadius: 20,
									}}>
									<h1 style={{ textAlign: 'center', color: 'white' }}>
										Instant Quote
									</h1>
								</Box>
								<h1 style={{ textAlign: 'center' }}>Valid Travel Dates:</h1>
								<p style={{ textAlign: 'center', fontSize: 12 }}>
									01-09-2018 - 30-01-2025
								</p>
								<Box style={{ padding: 10, background: 'lightgrey' }} mt={2}>
									<h1 style={{ textAlign: 'center' }}>Package Code:TR320357</h1>
								</Box>
							</Box>
						</Grid>
					</Grid>
				</Container>
				<Footer />
			</Watermark>
		</div>
	);
};

export default HolidaysDetailPage;
